<template>
  <div class="affair-container">
    <template v-if="viewType === 'list'">
      <search-box  ref="search" :status-list="statusList" @change="research"></search-box>
      <div class="contentBox">
        <div  class="contentTable">
          <el-table :data="tableData" size="medium">
            <el-table-column
                    prop="flowNo"
                    label="流程编号"
                    width="180">
            </el-table-column>
            <el-table-column
                    prop="typeName"
                    label="类型">
            </el-table-column>
            <el-table-column
                    prop="applyUserName"
                    label="申请人">
            </el-table-column>
            <el-table-column
                    prop="description"
                    label="描述">
            </el-table-column>
            <el-table-column
                    prop="submitTime"
                    label="申请时间">
            </el-table-column>
            <el-table-column
                    prop="userList[0].name"
                    label="上节点提交人">
            </el-table-column>
            <el-table-column
                    prop="dealTime"
                    label="上节点提交时间">
            </el-table-column>
            <el-table-column
                    prop="status"
                    label="状态">
              <template slot-scope="scope">
                <span class="status" :class=[$reconava.getStatusClass(scope.row.status)]>
                  {{$reconava.getStatusName(scope.row.status)}}</span>
              </template>
            </el-table-column>
            <el-table-column  width="100" label="操作">
              <template slot-scope="scope">
                <span @click="see(scope.row)" class="blue">查看</span>
              </template>
            </el-table-column>
          </el-table>
          <ReconovaPagination
                  v-if="tableData.length > 0"
                  @paginationChange="paginationChange"
                  :page-no="search.pageNum"
                  :page-size="search.pageSize"
                  :total="total"
          >
          </ReconovaPagination>

        </div>

      </div>
    </template>
    <template v-if="viewType === 'see'">
      <check-detail @cancel="cancel" :id="currentId" type="see" from="approval"></check-detail>
    </template>

    <template v-else-if="viewType === 'approvalDetail'">
      <approval-detail @changeType="close" type="approval" :id="currentId"></approval-detail>
    </template>

    <template v-else-if="viewType === 'flowDetail'">
      <flow-detail @changeType="close" type="approval" :id="currentId"></flow-detail>
    </template>

    <template v-else-if="viewType === 'contractDetail'">
      <labor-contract-detail @changeType="close" :id="currentId" from="approval"></labor-contract-detail>
    </template>

    <template v-else-if="viewType === 'positiveDetail'">
      <positive-detail @changeType="close" :id="currentId" from="approval"></positive-detail>
    </template>

    <template
      v-else-if="['dynamicFormDetail', 'dynamicFormEdit'].includes(viewType)"
    >
      <dynamic-form-wrapper
        :id="currentId"
        :viewType="viewType"
        @changeType="close"
      ></dynamic-form-wrapper>
    </template>

  </div>
</template>

<script>
  import SearchBox from "./searchBox";
  import ReconovaPagination from "@/components/reconova/reconovaPagination";
  import CheckDetail from "../../businessModule/examine/formDetail/checkDetail";
  import mixins from "./components/mixins";
  import {completedList} from "../../../services/checkModule";
  import LaborContractDetail from "../../businessModule/personnel/labor-contract/detail";
  import PositiveDetail from "../../businessModule/personnel/positive/detail";
  import DynamicFormWrapper from "./components/dynamicFormWrapper.vue";
  export default {
    name: "approval",
    components: {PositiveDetail, LaborContractDetail, CheckDetail, ReconovaPagination, SearchBox, DynamicFormWrapper },
    mixins: [ mixins ],
    data() {
      return {
        currentId:'',
        viewType:'list', //list 查看  see查看
        search:{pageNum:1,pageSize:20},
        statusList:[{label:"全部",value:""},{label:"处理中",value:"0"},{label:"已通过",value:"1"},{label:"已驳回",value:"2"},{label:"已终止",value:"5"}],
        tableData:[],
        total:0
      }
    },
    methods: {
      cancel(){
        this.viewType = 'list'
      },
      research(form){
        this.search.pageNum = 1;
        this.$nextTick(()=>{
          this.getData()
        })
      },
      //获取列表数据
      getData(){
        let search = Object.assign(this.search,this.$refs.search.getQuery())
        search.keyList =
        (search.keyList && search.keyList.join && search.keyList.join(",")) ||
        "";
        completedList(search).then(res => {
          this.tableData = res.data.list.map(item => {
          return {
            ...item,
            description: item.content ? item.content.description : '',
          }
        });
          this.total = res.data.total
        })
      },
      //翻页
      paginationChange(type, val) {
        if (type === "pageNo") {
          this.search.pageNum = val;
        } else {
          this.search.pageNum = 1;
          this.search.pageSize = val;
        }
        this.getData()
      },
    },
    mounted() {
      this.getData()
    }
  }
</script>

<style scoped lang="scss">
@import "css/examine.scss";
</style>
